import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';

interface Entry {
	response: HttpResponse<unknown>;
	expiresAt: number;
}

@Injectable({ providedIn: 'root' })
export class HttpCacheService {
	private store = new Map<string, Entry>();

	get(key: string): HttpResponse<unknown> | null {
		const entry = this.store.get(key);
		if (!entry) return null;
		if (Date.now() > entry.expiresAt) {
			this.store.delete(key);
			return null;
		}
		return entry.response.clone();
	}

	set(key: string, resp: HttpResponse<unknown>, ttlMs: number): void {
		this.store.set(key, {
			response: resp.clone(),
			expiresAt: Date.now() + ttlMs
		});
	}

	invalidate(prefix?: string) {
		if (!prefix) {
			this.store.clear();
			return;
		}
		for (const k of [...this.store.keys()]) {
			if (k.startsWith(prefix)) this.store.delete(k);
		}
	}
}
